import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sn-player-footer-row, [snPlayerFooterRow]',
  templateUrl: './player-footer-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-player__footer-row',
  },
})
export class SnPlayerFooterRowComponent {
  constructor() {}
}
